























import {Component, Vue} from 'vue-property-decorator';

@Component
export default class BadCinematics extends Vue {

    private videoPlaying = false;

    get playerDimensions() {
        if (window.innerWidth < 540) {
            return {width: 384, height: 216};
        }

        if (window.innerWidth < 700) {
            return {width: 512, height: 288};
        }

        if (window.innerWidth < 800) {
            return {width: 640, height: 360};
        }

        if (window.innerWidth < 900) {
            return {width: 788, height: 432};
        }

        if (window.innerWidth < 1050) {
            return {width: 896, height: 504};
        }

        return {width: 1024, height: 576};
    }

    public playVideo() {
        this.videoPlaying = true;
    }
}
